import { render, staticRenderFns } from "./CollapsiblePortlet.vue?vue&type=template&id=680d5836&"
import script from "./CollapsiblePortlet.vue?vue&type=script&lang=js&"
export * from "./CollapsiblePortlet.vue?vue&type=script&lang=js&"
import style0 from "./CollapsiblePortlet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports